//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            utilEdit: false,
            propertyUtilityDataLoading: false,
            propSettings: {}
        };
    },


    methods: {
        close: function close() {
            Event.$emit('close-full-modal');
        },
        load: function load() {
            var _this = this;

            this.$children[0].$data.showModal = true;
            axios.get('/prototype/properties/generalSettings').then(function (response) {
                _this.propSettings = response.data;
            });
        },
        savePropertyUtilityData: function savePropertyUtilityData() {
            var _this2 = this;

            this.utilEdit = false;
            this.propertyUtilityDataLoading = true;
            axios.post('/prototype/properties/' + this.$store.state.selectedProperty + "/generalSettings", {
                propSettings: this.propSettings
            }).then(function (response) {
                _this2.propSettings = response.data;
                _this2.propertyUtilityDataLoading = false;
            });
        }
    },

    created: function created() {
        Event.$on('property-settings-utilities', this.load);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('property-settings-basic-utilities');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/settings/PropertySettingsUtilities.vue
// module id = a8gI
// module chunks = 0 1